import { render, staticRenderFns } from "./InvoiceLoader.vue?vue&type=template&id=39b40d51&"
import script from "./InvoiceLoader.vue?vue&type=script&lang=js&"
export * from "./InvoiceLoader.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports